import qs from 'querystring';
import getResponseJson from './getresponsejson';

const LINES_OF_BUSINESS = {
  RAM: 'RAM'
};

export const reviewSearchService = serviceRoutes => {
  const init = () => {
    const lineOfBusiness = LINES_OF_BUSINESS.RAM;

    const params = { lineOfBusiness };
    const queryString = qs.stringify(params);
    const url = `${serviceRoutes.init}?${queryString}`;

    return fetch(url, {
      credentials: 'include',
      method: 'GET'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const getCodersForContract = contractId => {
    const params = { contractId };
    const queryString = qs.stringify(params);
    const url = `${serviceRoutes.getCodersForContract}?${queryString}`;

    return fetch(url, {
      credentials: 'include',
      method: 'GET'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const search = dto => {
    return fetch(serviceRoutes.search, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...dto
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  return {
    init,
    getCodersForContract,
    search,
    serviceRoutes
  };
};

export default reviewSearchService;
